import StatusDot from './StatusDot';
export { StatusDotOnColor, StatusDotVariant } from './constants';
export * from './StatusDot';
export default StatusDot;
